var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00004 5.27778C5.00004 4.51071 5.62187 3.88889 6.38893 3.88889H9.44449V7.5C9.44449 8.57389 10.315 9.44444 11.3889 9.44444H15V10.2778C15 10.738 15.3731 11.1111 15.8334 11.1111C16.2936 11.1111 16.6667 10.738 16.6667 10.2778V8.61111C16.6667 8.3901 16.5789 8.17813 16.4226 8.02185L10.8671 2.4663C10.7108 2.31002 10.4988 2.22222 10.2778 2.22222H6.38893C4.70139 2.22222 3.33337 3.59024 3.33337 5.27778V14.7222C3.33337 16.4098 4.70139 17.7778 6.38893 17.7778H10C10.4603 17.7778 10.8334 17.4047 10.8334 16.9444C10.8334 16.4842 10.4603 16.1111 10 16.1111H6.38893C5.62187 16.1111 5.00004 15.4893 5.00004 14.7222V5.27778ZM13.8215 7.77778L11.1112 5.0674V7.5C11.1112 7.65341 11.2355 7.77778 11.3889 7.77778H13.8215Z",
    fill: "#002CFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5556 12.7778C15.5556 12.3175 15.1825 11.9444 14.7223 11.9444C14.262 11.9444 13.8889 12.3175 13.8889 12.7778V16.0437L13.0893 15.2441C12.7639 14.9186 12.2362 14.9186 11.9108 15.2441C11.5853 15.5695 11.5853 16.0971 11.9108 16.4226L14.133 18.6448C14.4584 18.9702 14.9861 18.9702 15.3115 18.6448L17.5337 16.4226C17.8592 16.0971 17.8592 15.5695 17.5337 15.2441C17.2083 14.9186 16.6807 14.9186 16.3552 15.2441L15.5556 16.0437V12.7778Z",
    fill: "#002CFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageDown);
export default __webpack_public_path__ + "static/media/PageDown.69d2b9ce9fd4f5e5f5bc1a75d61eb56d.svg";
export { ForwardRef as ReactComponent };